import React from 'react';
import PropTypes from 'prop-types';

const InviteSuggestion = props => (
  <div>
    <h3>{props.translations['wide-net']}</h3>
    <p>
      {props.invites.program &&
      props.invites.program.restrictedEmails &&
      props.invites.program.restrictedEmails.length > 0
        ? props.translations['restricted-invite-suggestion']
        : props.translations['invite-suggestion']}
    </p>
    <p>{props.translations['do-immediately']}</p>
    <button
      type="button"
      onClick={() => props.displayModal('')}
      style={{ backgroundColor: props.color }}
    >
      {props.translations.done}
    </button>
  </div>
);

InviteSuggestion.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  displayModal: PropTypes.func.isRequired,
  invites: PropTypes.shape({
    program: PropTypes.shape({
      restrictedEmails: PropTypes.array,
    }),
  }),
};

InviteSuggestion.defaultProps = {
  invites: {},
};

export default InviteSuggestion;
